<template>
  <transition name="fade">
    <div class="mask" id="mask" v-if="show" @click="hidePop">
      <div class="popup">
        <div class="nav-tab">
          <span
            :class="[activeIndex === index ? 'active' : '', 'tab']"
            v-for="(item, index) in tabs"
            :key="index"
            @click="changeTab(index)"
            >{{ item }}</span
          >
        </div>
        <div class="form" v-if="activeIndex === 0">
          <div class="input-box">
            <input
              type="text"
              v-model="accountForm.userid"
              placeholder="请输入邮箱/手机号码"
              @input="accountInputChange"
            />
          </div>
          <div class="input-box">
            <input
              type="password"
              v-model="accountForm.password"
              placeholder="请输入密码"
              @input="accountInputChange"
            />
          </div>
          <div v-if="needCaptcha" class="input-box img-captcha account-box">
            <input
              type="text"
              v-model="accountForm.captcha"
              placeholder="图片验证码"
            />
            <img
              @click="getAccountCaptcha"
              :src="
                accountPictureUrl ||
                  'https://v4.passport.sohu.com/i/captcha/picture?pagetoken=1594712048404&random=passport403_sdk1594712048402'
              "
            />
          </div>
          <div class="error" v-if="error">
            <span>{{ error }}</span>
          </div>
          <div class="check">
            <span
              :class="[checked ? 'auto-checked' : '', 'auto']"
              @click="checked = !checked"
            ></span>
            <span class="text">下次自动登录</span>
          </div>
          <div class="login" @click="accountLogin">登录</div>
          <div class="other">
            <a class="forget" target="_blank" :href="forgetHref">忘记密码</a>
            <a class="register" target="_blank" :href="signUpHref">立即注册</a>
          </div>
        </div>
        <div class="form" v-if="activeIndex === 1">
          <div class="input-box">
            <input
              type="text"
              maxlength="11"
              v-model="phoneLoginForm.mobile"
              placeholder="请输入手机号"
              @input="handlePhoneInput"
            />
          </div>
          <div class="input-box img-captcha">
            <input
              type="text"
              v-model="phoneLoginForm.captcha"
              placeholder="请输入图片验证码"
              @input="phoneInputChange"
            />
            <img
              @click="getCaptcha"
              :src="
                pictureUrl ||
                  'https://v4.passport.sohu.com/i/captcha/picture?pagetoken=1594712048404&random=passport403_sdk1594712048402'
              "
            />
          </div>
          <div class="input-box phone-code">
            <input
              type="text"
              v-model="phoneLoginForm.smcode"
              maxlength="6"
              placeholder="手机验证码"
              @input="handleSmcodeInput"
            />
            <span v-if="!isCounting" class="code-btn" @click="getPhoneCode"
              >获取验证码</span
            >
            <span v-else class="code-btn">{{ btnText }}</span>
          </div>
          <div class="error" v-if="phoneErr">
            <span>{{ phoneErr }}</span>
          </div>
          <div class="check">
            <span
              :class="[checked ? 'auto-checked' : '', 'auto']"
              @click="checked = !checked"
            ></span>
            <span class="text">下次自动登录</span>
          </div>
          <div class="login" @click="phoneLogin">登录</div>
          <div class="other">
            <a class="forget" target="_blank" :href="forgetHref">忘记密码</a>
            <a class="register" target="_blank" :href="signUpHref">立即注册</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { getToken } from "../../../utils/auth";
export default {
  name: "HyPopup",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showError: false,
      checked: false,
      passport: "",
      forgetHref: `https://passport.sohu.com/password/forget?ru=${location.href}`,
      signUpHref: `https://passport.sohu.com/signup?ru=${location.href}`,
      tabs: ["账号登录", "手机登录"],
      activeIndex: 0,
      accountForm: {
        userid: "",
        password: ""
      },
      phoneLoginForm: {
        mobile: "",
        smcode: "",
        captcha: ""
      },
      pictureUrl: "",
      accountPictureUrl: "",
      timer: null,
      timeLeft: 0,
      btnText: "",
      isCounting: false,
      needCaptcha: false,
      error: "",
      phoneErr: "",
      accountFlag: true,
      phoneFlag: true,
      accountLoginCode: {
        400: "非法请求",
        404: "用户名或密码错误",
        420: "图片验证码不正确",
        423: "账户未设置密码",
        450: "用户名或密码为空",
        453: "帐号登录失败超过5次，ip被封锁",
        461: "需要绑定手机",
        465: "用户需输入图片验证码"
      },
      mobileLoginCode: {
        400: "非法请求",
        422: "手机验证码不正确",
        42201: "手机验证码不存在或已过期",
        427: "手机绑定上限，无法注册",
        450: "手机号或验证码为空",
        453: "失败超过5次，ip被封锁"
      },
      smcodeCode: {
        400: "非法请求",
        420: "图片验证码不正确",
        421: "验证码发送次数太多",
        450: "参数错误",
        461: "手机号格式不正确",
        464: "手机号不支持",
        474: "只能发送语音验证码",
        482: "操作过时",
        500: "服务器繁忙"
      }
    };
  },
  computed: {
    accountBtnDisabled() {
      return !this.accountForm.userid || !this.accountForm.password;
    },
    phoneBtnDisabled() {
      return (
        !this.phoneLoginForm.mobile ||
        !this.phoneLoginForm.smcode ||
        !this.phoneLoginForm.captcha
      );
    }
  },
  mounted() {
    /* eslint-disable */
    this.passport = new SohuPassport({
      appid: 110509 //必传。为passport为各个业务线分配的专属appid
    });
    this.getCaptcha()
    this.getAccountCaptcha()
    /* eslint-enable */
  },
  methods: {
    hidePop(e) {
      if (e.target.id === "mask") {
        this.$emit("hidePop");
      }
    },
    handlePhoneInput(e) {
      this.phoneLoginForm.mobile = e.target.value.replace(/[^\d]/g, "");
      if (this.phoneLoginForm.mobile.length === 0) {
        this.phoneErr = "手机号为空";
        return;
      }
      if (this.phoneLoginForm.mobile.length !== 11) {
        this.phoneErr = "手机号应为11位数字";
        return;
      }
      this.phoneErr = "";
    },
    handleSmcodeInput(e) {
      this.phoneLoginForm.smcode = e.target.value.replace(/[^\d]/g, "");
    },
    changeTab(index) {
      this.activeIndex = index;
    },
    accountInputChange() {
      this.error = "";
    },
    phoneInputChange() {
      if (this.phoneLoginForm.mobile.length === 0) {
        this.phoneErr = "手机号为空";
        return;
      }
      if (this.phoneLoginForm.mobile.length !== 11) {
        this.phoneErr = "手机号应为11位数字";
        return;
      }
      this.phoneErr = "";
    },

    getCaptcha() {
      this.pictureUrl = this.passport.getPhonePicture();
    },
    getAccountCaptcha() {
      this.accountPictureUrl = this.passport.getLoginPicture();
    },
    accountLogin() {
      if (!this.accountFlag) {
        return;
      }
      this.accountFlag = false;
      if (!this.accountForm.userid) {
        this.error = "用户名为空";
        return;
      }
      if (!this.accountForm.password) {
        this.error = "密码为空";
        return;
      }
      let reqData = {};
      if (this.needCaptcha) {
        reqData = {
          captcha: this.accountForm.captcha,
          userid: this.accountForm.userid, // 帐号(必传)
          password: this.accountForm.password, // 密码(必传)
          persistentCookie: this.checked ? "1" : "0" // 是否保留cookie，0：cookie为session级别(默认)，1：保留cookie14天(可选)
        };
      } else {
        reqData = {
          userid: this.accountForm.userid, // 帐号(必传)
          password: this.accountForm.password, // 密码(必传)
          persistentCookie: this.checked ? "1" : "0" // 是否保留cookie，0：cookie为session级别(默认)，1：保留cookie14天(可选)
        };
      }
      this.passport.login({
        params: reqData,
        success: data => {
          const ppinf = getToken("ppinf");
          this.$store.commit("SET_PPINF", ppinf);
          this.$toast("登录成功");
          this.$emit("hidePop");
          this.accountFlag = true;
          console.log(data);
        }, // 当status为2**时回调(可选)
        error: err => {
          if (err.status === 465) {
            this.needCaptcha = true;
          } else {
            this.error = this.accountLoginCode[err.status];
          }
          this.accountFlag = true;
          // this.$toast(this.accountLoginCode[err.status]);
        }
      });
    },
    phoneLogin() {
      if (!this.phoneFlag) {
        return;
      }
      this.phoneFlag = false;
      if (!this.phoneLoginForm.mobile) {
        this.phoneErr = "手机号为空";
        return;
      }
      if (
        !/\d+/.test(this.phoneLoginForm.mobile) ||
        this.phoneLoginForm.mobile.length !== 11
      ) {
        this.phoneErr = "手机号应为11位数字";
        return;
      }
      if (!this.phoneLoginForm.smcode) {
        this.phoneErr = "手机验证码为空";
        return;
      }

      if (
        !/\d+/.test(this.phoneLoginForm.smcode) ||
        this.phoneLoginForm.smcode.length !== 6
      ) {
        this.phoneErr = "手机验证码应为6位数字";
        return;
      }
      if (!this.phoneLoginForm.captcha) {
        this.phoneErr = "请输入图片验证码";
        return;
      }
      this.passport.mobileLogin({
        params: {
          mobile: this.phoneLoginForm.mobile, // 帐号(必传)
          smcode: this.phoneLoginForm.smcode, // 密码(必传)
          persistentCookie: this.checked ? "1" : "0" // 是否保留cookie，0：cookie为session级别(默认)，1：保留cookie14天(可选)
        },
        success: data => {
          const ppinf = getToken("ppinf");
          this.$store.commit("SET_PPINF", ppinf);
          this.$toast("登录成功");
          this.$emit("hidePop");
          this.phoneFlag = true;
          console.log(data);
        }, // 当status为2**时回调(可选)
        error: err => {
          console.log(err.status);
          this.phoneFlag = true;
          this.phoneErr = this.mobileLoginCode[err.status];
        }
      });
    },
    getPhoneCode() {
      if (this.timeLeft !== 0) {
        return;
      }
      if (!this.phoneLoginForm.mobile) {
        this.phoneErr = "手机号为空";
        return;
      }
      if (
        !/\d+/.test(this.phoneLoginForm.mobile) ||
        this.phoneLoginForm.mobile.length !== 11
      ) {
        this.phoneErr = "手机号应为11位数字";
        return;
      }
      if (!this.phoneLoginForm.captcha) {
        this.phoneErr = "图片验证码为空";
        return;
      }
      this.passport.getSignInCaptcha({
        params: {
          mobile: this.phoneLoginForm.mobile, // 手机号(必传)
          way: 0, // 短信发送方式，0：短信，1：语音(必传)
          captcha: this.phoneLoginForm.captcha // 图形验证码(必传)，captcha 与 validate 传一个即可
        },
        success: data => {
          console.log(data);
          this.$toast("验证码发送成功");
          this.startTimer();
        }, // 当status为2**时回调(可选)
        error: err => {
          this.phoneErr = this.smcodeCode[err.status];
        }
      });
    },
    startTimer() {
      this.timer && clearInterval(this.timer);
      this.timeLeft = 120;
      this.btnText = this.timeLeft + " s";
      this.isCounting = true;
      this.timer = setInterval(() => {
        this.timeLeft--;
        this.btnText = this.timeLeft + " s";
        if (this.timeLeft === 0) {
          this.timer && clearInterval(this.timer);
          this.btnText = "";
          this.isCounting = false;
        }
      }, 1000);
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  min-width: 100vh;
  z-index: 12;
  background: rgba(0, 0, 0, 0.4);
  .popup {
    z-index: 13;
    width: 581px;
    // height: 591px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 34px 56px 55px;
    box-sizing: border-box;
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 56px;
      letter-spacing: 1px;
    }
  }
}
.nav-tab {
  display: flex;
  justify-content: center;
  span {
    font-size: 20px;
    color: #666;
    display: inline-block;
    margin: 0 15px;
    cursor: pointer;
  }
  .active {
    transform: scale(1.25);
    color: #222;
    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -4px;
      width: 20px;
      height: 2px;
      background-color: #ffdd00;
    }
  }
}
.form {
  margin-top: 48px;
  .input-box {
    box-sizing: border-box;
    display: flex;
    input {
      width: 457px;
      height: 58px;
      border-radius: 4px;
      border: 1px solid rgba(174, 174, 174, 1);
      padding-left: 11px;
      font-size: 24px;
      &::placeholder {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(174, 174, 174, 1);
      }
    }

    &:nth-child(2) {
      margin-top: 30px;
    }
  }
  .img-captcha,
  .phone-code {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 58px;
    input {
      width: 300px;
    }
    img {
      width: 120px;
      display: flex;
    }
    .code-btn {
      width: 100px;
      text-align: center;
      line-height: 58px;
      font-size: 20px;
      border-radius: 4px;
      padding: 0 10px;
      border: 1px solid rgba(174, 174, 174, 1);
      cursor: pointer;
    }
  }
  .img-captcha {
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .account-box {
    margin-bottom: 0;
  }
  .check {
    line-height: 33px;
    margin-top: 48px;
    span {
      display: inline-block;
      vertical-align: middle;
    }
    .auto {
      width: 33px;
      height: 33px;
      border-radius: 4px;
      border: 2px solid rgba(174, 174, 174, 1);
      margin-right: 12px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .auto-checked {
      background: url("../../../assets/images/ic_kehuzidong@2x.png") no-repeat
        center center;
      background-size: contain;
      border: none;
    }
    .text {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 28px;
    }
  }
  .error {
    position: absolute;
    margin-top: 14px;
    color: red;
    i {
      border: 1px solid red;
      box-sizing: border-box;
      width: 14px;
      height: 14px;
      border-radius: 7px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      margin-right: 6px;
    }
    span {
      font-size: 18px;
      display: flex;
    }
  }
  .login {
    text-align: center;
    line-height: 70px;
    width: 469px;
    height: 70px;
    background: rgba(241, 148, 50, 1);
    border-radius: 4px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    letter-spacing: 1px;
    margin-top: 20px;
    cursor: pointer;
  }
  .other {
    margin-top: 21px;
    display: flex;
    justify-content: space-between;
    span,
    a {
      display: inline-block;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      &:hover {
        text-decoration: underline;
      }
    }
    .register {
      color: rgba(241, 148, 50, 1);
    }
  }
}
</style>
